import {
  Box,
  Heading,
  Container,
  Grid,
  Stack,
  HStack,
  Text,
  IconButton,
  useDisclosure,
  VStack,
  CircularProgress,
} from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";
import Button from "components/Button/Button";
// import Rating from "@material-ui/lab/Rating";
// import StarBorderIcon from "@material-ui/icons/Star";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import ConfirmationModal from "components/Modals/p2p/Confirmation";

import { useEffect, useCallback, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  useGetBuyTradeSessionQuery,
  useUpdateTradeSessionMutation,
} from "services/p2pApi";

import formatter from "util/formatter";
import { floatString } from "util/utils";
import { toUpper } from "lodash";
import { format, parseISO } from "date-fns";

import Messanger from "components/Messager/Messanger";

const Release = ({ data, trader, tradeId, frozenRef }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: cancelIsOpen, onClose: cancelOnClose } = useDisclosure();

  const [_updateTradeSession, { isLoading: isUpdating, isSuccess }] =
    useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation) =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );

  const getStatus = () => {
    return `${data?.contractState}&${trader?.obligationStatus}`;
  };

  useEffect(() => {
    if (isSuccess) {
      cancelOnClose();
    }
  }, [isSuccess, cancelOnClose]);

  return (
    <>
      <Box bg="#F4F2FF" p="28px 26px" borderRadius="6px">
        <HStack direction="row" gridGap="100px">
          <VStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm" mt="0px !important">
              From:
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="12px !important">
              Amount:
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="12px !important">
              Price:
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="12px !important">
              Quantity:
            </Text>
          </VStack>

          <VStack alignItems="flex-start">
            <HStack mt="0px !important">
              <Text fontSize="sm" mt="0 !important">
                {/* Chioma Adekunle Buhari */}
                {trader?.user?.username}
              </Text>
              {/* <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              /> */}
            </HStack>

            <HStack mt="12px !important">
              <Text fontSize="sm" mt="0 !important">
                {/* Guaranty Trust Bank */}
                {data?.currency && formatter(data.currency).format(data.amount)}
              </Text>
            </HStack>

            <HStack mt="12px !important" justifyContent="flex-start">
              <Text fontSize="sm">
                {data?.currency &&
                  formatter(data.currency).format(parseFloat(trader.unitCost))}
              </Text>
            </HStack>
            <HStack mt="12px !important" justifyContent="flex-start">
              <Text fontSize="sm">
                {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
              </Text>
            </HStack>
          </VStack>
        </HStack>
      </Box>

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        {/* <Button
          // h="56px"
          onClick={cancelOnOpen}
          minW="120px !important"
          // px="10px"
          bg="transparent"
          border="2px solid transparent"
          color="#03A438"
        >
          Cancel trade
        </Button> */}
        <Button
          disabled={getStatus() !== "open&fulfilled"}
          onClick={onOpen}
          minW="120px !important"
        >
          Release
        </Button>
      </HStack>

      <Stack
        borderTop="1px solid #D9DBE9"
        p="26px 0"
        // borderBottom="1px solid #D9DBE9"
      >
        <Heading fontSize="md">Listing Details</Heading>

        <Stack mt="24px !important">
          <HStack>
            <Text fontSize="sm" color="#4E4B66">
              Price
            </Text>
            <Text fontSize="sm" color="#4E4B66">
              <strong>{Number(trader.unitCost).toLocaleString()} </strong>
              <Box as="span" d="inline-block" fontSize="xs">
                {toUpper(data?.currency)}
              </Box>
            </Text>
          </HStack>

          <HStack>
            <Text fontSize="sm" color="#4E4B66">
              Available
            </Text>
            <Text fontSize="sm" color="#4E4B66">
              <strong>
                {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
              </strong>
            </Text>
          </HStack>

          <HStack>
            <Text fontSize="sm" color="#4E4B66">
              Time limit
            </Text>
            <Text fontSize="sm" color="#4E4B66">
              <strong>{trader?.timeline?.duration} mins</strong>
            </Text>
          </HStack>

          {/* <HStack>
            <Text fontSize="sm" color="#4E4B66">
              Location
            </Text>
            <Text fontSize="sm" color="#4E4B66">
              <strong>{trader?.timeline?.duration} mins</strong>
            </Text>
          </HStack> */}
        </Stack>
      </Stack>

      {/* <Stack
        borderTop="1px solid #D9DBE9"
        p="26px 0"
        borderBottom="1px solid #D9DBE9"
      >
        <Heading fontSize="md">Terms</Heading>

        <Text>{}</Text>
      </Stack> */}

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("RELEASETRADE")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            Confirm this is not an accident and acknowledge that the{" "}
            <strong>
              {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
            </strong>{" "}
            token are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>
    </>
  );
};

const Cancelled = ({ timeout }) => {
  return (
    <>
      <Box
        // mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        {/* <Heading fontSize="sm">Order Cancelled</Heading> */}

        <HStack>
          <Text fontSize="sm" color="#4E4B66">
            Order has been cancelled by the buyer.
          </Text>
        </HStack>
      </Box>
    </>
  );
};

const Timedout = ({ timeout }) => {
  return (
    <>
      <Box
        // mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        {/* <Heading fontSize="sm">Order Cancelled</Heading> */}

        <HStack>
          <Text fontSize="sm" color="#4E4B66">
            Order timedout.
          </Text>
        </HStack>
      </Box>
    </>
  );
};

const Completed = ({ data }) => {
  const history = useHistory();
  return (
    <>
      <Box
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        {/* <Heading fontSize="sm">Order Completed</Heading> */}

        <HStack>
          <Text fontSize="sm" color="#4E4B66">
            {toUpper(data?.coin ?? "")} has been release and order has been
            completed.
          </Text>
        </HStack>
      </Box>

      <Stack p="20px 0" maxW="100px">
        <Button
          onClick={() => history.replace("/dashboard/wallet")}
          bg="transparent"
          minW="80px !important"
          fontSize="xs"
          fontWeight="400"
          color="#03A438"
          p="0 !important"
        >
          View wallet
        </Button>
      </Stack>
    </>
  );
};

const ReleaseTradeAsset = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [, setStatus] = useState("release");
  const { id } = useParams();
  const { data, isLoading } = useGetBuyTradeSessionQuery(id, {
    pollingInterval: isCompleted ? 0 : 5000,
  });

  const [tradeId, frozenRef] = (data && String(id).split("-")) ?? [];

  console.log("TRADE SESSION", data, props.userData);

  const getTrader = () =>
    data?.counterParties?.find((cp) => cp.role === "trader");

  const getTradeOwner = useCallback(
    () => data?.counterParties?.find((cp) => cp.role === "tradeowner"),
    [data?.counterParties]
  );

  const getStatus = useCallback(
    () => `${data?.contractState}&${getTradeOwner()?.obligationStatus}`,
    [data?.contractState, getTradeOwner]
  );

  const orderStatusTextMap = {
    open: "Received",
    closed: "Completed",
    cancelled: "Cancelled",
  };

  useEffect(() => {
    if (
      data?.contractState === "closed" ||
      data?.contractState === "timeout" ||
      data?.contractState === "cancelled" ||
      getStatus() === "open&fulfilled"
    ) {
      setIsCompleted(true);
    }
  }, [data, getStatus]);

  const mapStatusToComponent = (status) => {
    const map = {
      "open&pending": (
        <Release
          data={data}
          trader={getTrader()}
          tradeId={tradeId}
          frozenRef={frozenRef}
        />
      ),
      "closed&fulfilled": (
        <Completed data={data} trader={getTrader()} setStatus={setStatus} />
      ),
      "open&fulfilled": (
        <Completed data={data} trader={getTrader()} setStatus={setStatus} />
      ),
      "cancelled&pending": (
        <Cancelled timeout={data && getTrader()?.timeline?.duration} />
      ),
      "timeout&fulfilled": (
        <Timedout timeout={data && getTrader()?.timeline?.duration} />
      ),
    };

    return map[status];
  };

  console.log("GET STATUS", data && getStatus());
  return (
    <Box
      __css={{
        "--color": "#4E4B66",
        "--borderColor": "#D9DBE9",
        "--focusColor": "#06c34491",
        "--primary": "#03A438",
      }}
    >
      <Sidemenu currentPage="P2P" logoutUser={props.logout} />
      <Header />

      <Box className="p2p">
        <Box className="p2p-container">
          {isLoading && (
            <CircularProgress isIndeterminate size="20px" color="green" />
          )}

          {!isLoading && (
            <Container maxW="container.xl">
              <Heading fontSize="3xl">Sell {toUpper(data?.coin ?? "")}</Heading>

              <Grid
                templateColumns=".55fr .4fr"
                overflow="hidden"
                mt="48px"
                gridGap="20px"
              >
                <Box bg="white" borderRadius="16px" h="fit-content">
                  <HStack
                    alignItems="flex-start"
                    justifyContent="space-between"
                    p="20px 32px"
                    borderBottom="1px solid #D9DBE9"
                    flexWrap="wrap"
                  >
                    <Stack pb="20px">
                      <Text fontWeight="bold">
                        Order {orderStatusTextMap[data?.contractState]}
                      </Text>
                    </Stack>

                    <HStack
                      alignItems="flex-start"
                      gridGap="32px"
                      ml="0 !important"
                    >
                      <Stack>
                        <Text color="#4E4B66" fontSize="sm">
                          Date
                        </Text>
                        <Text fontSize="sm" mt="0px !important">
                          {/* 17-06-2021 */}

                          {data &&
                            format(parseISO(data?.createdAt), "dd-MM-yyy")}
                        </Text>
                      </Stack>
                      <Stack>
                        <Text color="#4E4B66" fontSize="sm">
                          Time
                        </Text>
                        <Text fontSize="sm" mt="0px !important">
                          {data && format(parseISO(data?.createdAt), "HH:mm")}
                        </Text>
                      </Stack>
                      <Stack>
                        <Text color="#4E4B66" fontSize="sm">
                          ID
                        </Text>
                        <HStack mt="0px !important">
                          <Text fontSize="sm">{data?.id}</Text>
                          <IconButton
                            size="xs"
                            variant="ghost"
                            aria-label="copy"
                            icon={<CopyIcon />}
                          />
                        </HStack>
                      </Stack>
                    </HStack>
                  </HStack>

                  <Stack p="32px">{mapStatusToComponent(getStatus())}</Stack>
                </Box>

                <Messanger />
              </Grid>
            </Container>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ReleaseTradeAsset;
